import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'
import {store} from './Redux'

import {DOMAIN, ENVIRONMENT} from "./Constants";
import {config} from "./Config";
import {StreamBankApp} from "./StreamBankApp";

config.setValues({
    store: store,
    domain: DOMAIN,
    environment: ENVIRONMENT
});


// Render HTML on the browser
ReactDOM.render(
    <Provider store={store}>
        <StreamBankApp />
    </Provider>,
    document.getElementById('root')
);
